module.exports = __webpack_public_path__ + "img/243.food.48d3ea4d.svg";